import { connect } from 'react-redux'
import { sagaActions } from 'store/sagas'
import userProfileSelector from './userProfileSelector'
import {
  showProfile
} from 'store/redux/layout'
import UserProfile from './UserProfile'

export default connect(
  userProfileSelector,
  {
    fetchProfile: sagaActions.fetchProfile,
    requestChangeCurrentUserProfile: sagaActions.requestChangeCurrentUserProfile,
    requestChangeCurrentUserAvatar: sagaActions.requestChangeCurrentUserAvatar,
    showProfile
  }
)(UserProfile)

